import Axios from '@/libs/services'

const Request = new Axios()

const version = 'v1'

class Api {
  getTiers = () => {
    const service = 'subscription-tiers/?expand=*'

    return Request.get({ service, version })
  }

  getCycles = () => {
    const service = 'subscription-cycles/'

    return Request.get({ service, version })
  }

  getSubscriptions = () => {
    const service = 'subscriptions/'

    return Request.get({ service, version })
  }

  /**
   * Fetch organization subscriptions with optional state filter (v2 API).
   * @param {string[]} [states] - Optional list of states: ACTIVE, EXPIRED, CANCELED, PAYMENT_PENDING, PAYMENT_FAILED
   */
  getSubscriptionsV2 = (states = null) => {
    const service = 'subscriptions/'
    const query = states?.length ? { state: states } : undefined

    return Request.get({ service, version: 'v2', query, skipSnakeCase: true })
  }

  calculateTierPrice = (tierId, cycleId) => {
    const service = `subscription-tiers/${tierId}/price/`

    return Request.post({ service, version, body: { cycle: cycleId } })
  }

  purchaseSubscriptionTier = (tierId, cycleId) => {
    const service = `subscription-tiers/${tierId}/purchase/`

    return Request.post({ service, version, body: { cycle: cycleId } })
  }

  sendPurchaseOrder = data => {
    const service = 'subscription-purchase-orders/'

    return Request.post({ service, version: 'v2', body: data, skipSnakeCase: true })
  }
}

export default new Api()
